const map = {
	"./exams-form": 394,
	"./exams-form.js": 394,
	"./home": 816,
	"./home.js": 816,
	"./tcf-form": 801,
	"./tcf-form.js": 801,
	"./tcf-home": 124,
	"./tcf-home.js": 124
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 948;